import Tooltip from "@atlaskit/tooltip";
import CheckCircleIcon from "@atlaskit/icon/glyph/check-circle";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import EditorErrorIcon from "@atlaskit/icon/glyph/editor/error";
import Spinner from "@atlaskit/spinner";
import EmojiFrequentIcon from "@atlaskit/icon/glyph/emoji/frequent";
import { jobStatus } from "../../constants/constants";
import Skeleton from "react-loading-skeleton";
import { secondsToDhms } from "../../helpers/helpers";
export const createHead = (withWidth) => {
  return {
    cells: [
      {
        key: "id",
        content: "Status",
        isSortable: false,
        width: withWidth ? 5 : undefined,
      },
      {
        key: "event",
        content: "Project name",
        isSortable: false,
        width: withWidth ? 30 : undefined,
      },
      {
        key: "action",
        content: "Total issues count",
        isSortable: false,
        width: withWidth ? 9 : undefined,
      },

      {
        key: "timestamp",
        content: "Updated issues count",
        isSortable: false,
        width: withWidth ? 9 : undefined,
      },
      {
        key: "accountId",
        content: "Total attachments count",
        isSortable: false,
        width: withWidth ? 9 : undefined,
      },
      {
        key: "userName3",
        content: "Updated attachments count",
        isSortable: false,
        width: withWidth ? 9 : undefined,
      },
      {
        key: "Total issues size",
        content: "Total attachments size",
        isSortable: false,
        width: withWidth ? 9 : undefined,
      },
      {
        key: "Total issues size",
        content: "Updated attachment size",
        isSortable: false,
        width: withWidth ? 9 : undefined,
      },
      {
        key: "timeTaken",
        content: "Time Taken",
        isSortable: false,
        width: withWidth ? 40 : undefined,
      },
    ],
  };
};

function createKey(input) {
  return input ? input.replace(/^(the|a|an)/, "").replace(/\s/g, "") : input;
}

export const createCells = (moreJobDetails) =>
  moreJobDetails.map((data, index) => ({
    key: `row-${index}`,
    cells: [
      {
        key: createKey(data.totalAttachmentCount.toString()),
        content: (
          <div style={{ textAlign: "center" }}>
            <Tooltip content={jobStatus[data.status]} position="left">
              <div>
                {data.status === 1 && <EmojiFrequentIcon size="small" />}
                {data.status === 2 && <Spinner size="small" />}
                {data.status === 3 && (
                  <CheckCircleIcon primaryColor="green" size="small" />
                )}
                {data.status === 4 && (
                  <WarningIcon primaryColor="orange" size="small" />
                )}
                {data.status === 5 && (
                  <EditorErrorIcon primaryColor="red" size="small" />
                )}
              </div>
            </Tooltip>
          </div>
        ),
      },
      {
        key: createKey(data.projectName.toString()),
        content: <div>{data.projectName}</div>,
      },

      {
        key: createKey(data.totalIssuesCount.toString()),
        content: data.totalIssuesCount,
      },

      {
        key: createKey(data.updatedIssuesCount.toString()),
        content: (
          <div>
            {data.status === 1 ? (
              <Skeleton width="50px" />
            ) : (
              data.updatedIssuesCount
            )}
          </div>
        ),
      },
      {
        key: createKey(data.totalAttachmentCount.toString()),
        content: (
          <div>
            {data.status === 1 ? (
              <Skeleton width="50px" />
            ) : (
              data.totalAttachmentCount
            )}
          </div>
        ),
        //content: moment(data.date).format("llll"),
      },
      {
        key: createKey(data.updatedAttachmentCount.toString()),
        content: (
          <div>
            {data.status === 1 ? (
              <Skeleton width="50px" />
            ) : (
              data.updatedAttachmentCount
            )}
          </div>
        ),
      },

      {
        key: createKey(data.totalIssuesSize.toString()),
        content: (
          <div>
            {data.status === 1 ? (
              <Skeleton width="50px" />
            ) : (
              data.totalAttachmentsSizeInString
            )}
          </div>
        ),
      },
      {
        key: createKey(data.updatedIssuesSize.toString()),
        content: (
          <div>
            {data.status === 1 ? (
              <Skeleton width="50px" />
            ) : (
              data.updateAttachmentsSizeInString
            )}
          </div>
        ),
      },
      {
        key: createKey(data.timeTaken.toString()),
        content: (
          <div>
            {data.status === 1 || data.status === 2 ? (
              <Skeleton width="50px" />
            ) : (
              secondsToDhms(data.timeTaken)
            )}
          </div>
        ),
      },
    ],
  }));
